import PostPurchaseView from './PostPurchaseView'
export default PostPurchaseView
